import { useEffect, useState, useRef } from "react"
import Block from "@/components/wrappers/block"
import Button from "@/components/common/button/button"
import styles from "./press-via-tt.module.css"
import useCookieBot from "@/lib/hooks/useCookieBot"
import { Spinner } from "@/components/common/loading/spinner"

export default function PressViaTT({ block }) {
  const { loading, statistics } = useCookieBot()

  if (!block.attrs.publisher) {
    return null
  }

  return (
    <Block width="full" block={block} className={styles.wrapper}>
      {loading && (
        <div className="p-16 pb-20 text-center">
          <Spinner
            size="large"
            borderClass="border-green-100"
            spinColor="#ECF2CA"
            className="mx-auto"
          />
        </div>
      )}
      {!loading && !statistics && (
        <div className="no-consent">
          <p>
            För att se detta innehåll behöver du godkänna cookies av typen{" "}
            <b>Statistik</b>.
          </p>
          {!statistics && (
            <Button
              theme="lime"
              ariaLabel="Ändra inställningar"
              size="small"
              onClick={() => window.Cookiebot.renew()}>
              Ändra inställningar
            </Button>
          )}
        </div>
      )}
      {!loading && statistics && <Iframe block={block} />}
    </Block>
  )
}

const Iframe = ({ block }) => {
  const iframeRef = useRef(null)
  const [height, setHeight] = useState(2800)

  const pressRoomURL =
    "//via.tt.se/embedded/pressroom?publisherId=" + block.attrs.publisher

  const handleResize = () => {
    if (window.outerWidth < 321) {
      setHeight(8850)
      return
    }

    if (window.outerWidth < 376) {
      setHeight(8300)
      return
    }

    if (window.outerWidth < 541) {
      setHeight(5200)
      return
    }

    if (window.outerWidth < 769) {
      setHeight(5100)
      return
    }

    if (window.outerWidth < 1025) {
      setHeight(4800)
      return
    }

    if (window.outerWidth < 1241) {
      setHeight(4750)
      return
    }

    if (window.outerWidth < 1281) {
      setHeight(3700)
      return
    }

    if (window.outerWidth < 1541) {
      setHeight(3800)
      return
    }

    setHeight(2800)
  }

  useEffect(() => {
    handleResize()

    window.addEventListener("resize", handleResize)

    return () => {
      window.removeEventListener("resize", handleResize)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className="iframe-wrapper">
      <iframe
        key={pressRoomURL}
        ref={iframeRef}
        width="100%"
        height={height}
        src={pressRoomURL}
        id="embedded-pressroom-iframe"
      />
    </div>
  )
}
